export default __webpack_public_path__ + "static/vbox-99aa2167a240116effe092c049581aeb.png";